<template>
	<core-modal
		name="bulk-delete-modal"
		class="omapi-modal bulk-delete-modal"
		:clickToClose="!isBulkDeleting"
		:isConfirmation="true"
	>
		<modals-content>
			<form @submit.prevent="deleteCampaignHandler">
				<p>Are you sure you want to <strong>permanently delete {{ bulk.length }} campaign{{ bulk.length > 1 ? 's' : '' }}</strong>? This will <strong>also delete any split tests </strong> that were connected to this campaign.</p>

				<section class="buttons">
					<core-loading-button
						class="bulk-delete-campaign"
						size="large"
						color="blue"
						:loading="isBulkDeleting"
						buttonType="submit"
					>
						Yes, I'm Sure
					</core-loading-button>
					<button
						class="omapi-button omapi-button__white omapi-button__large"
						@click.prevent="$modal.hide('bulk-delete-modal')"
						:disabled="isBulkDeleting"
					>Cancel</button>
				</section>
			</form>
		</modals-content>
	</core-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'
export default {
	data () {
		return {
			isBulkDeleting : false,
		}
	},
	computed : {
		...mapState('campaigns', [ 'bulk' ]),
	},
	methods : {
		...mapActions([ 'bulkDeleteCampaigns' ]),
		async deleteCampaignHandler () {
			const count = this.bulk.length
			this.isBulkDeleting = true

			await this.bulkDeleteCampaigns()

			this.isBulkDeleting = false
			this.$store.commit('campaigns/addAlert', {
				message : `Successfully deleted ${count} campaign${1 < count ? 's' : ''}.`,
				type    : 'success',
			})
			this.$modal.hide('bulk-delete-modal')
		},
	},
}
</script>

<style lang="scss">
.bulk-delete-modal {

}
</style>
